import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { HCPClassService } from '../hcpClass.service';
import { hcpClass } from '../../../models/lookups/hcpClass.model';
import { DisplayModes } from '../../../models/enums';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { BusinessUnitService } from '../../business-unit/business-unit.service';
import { BusinessUnit } from '../../../models/lookups/business-unit.model';


@Component({
  selector: 'crm-add-hcpClass',
  templateUrl: './add-hcpClass.component.html',
  styleUrls: ['./add-hcpClass.component.css']
})
export class AddhcpClassComponent implements OnInit {
  hcpclass: any = {} as any;

  hcpClassid: number;
  displayMode: DisplayModes = DisplayModes.Success;
  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() hcpClassId: number;
  months: any[] = [{ id: 1, name: 'January' }, { id: 2, name: 'February' }, { id: 3, name: 'March' }, { id: 4, name: 'April' }, { id: 5, name: 'May' }, { id: 6, name: 'June' }, { id: 7, name: 'July' },
  { id: 8, name: 'August' }, { id: 9, name: 'September' }, { id: 10, name: 'October' }, { id: 11, name: 'November' }, { id: 12, name: 'December' }];

  businessUnits: BusinessUnit[] = [];
  constructor(private alertService: AlertService,
    private route: ActivatedRoute, private readonly businessUnitService: BusinessUnitService,
    private hcpClassService: HCPClassService,
    private translateService: AppTranslationService,
    private router: Router) { }

  ngOnInit() {
    const url = window.location.href;
    this.hcpclass.isHcpClass = url.includes("hcp-class");
    this.getBusinessUnits();
    this.hcpClassid = this.hcpClassId;
    if (this.hcpClassid != undefined)
      this.getDetails(this.hcpClassid);
    //this.route.params.subscribe(params => {
    //  this.hcpClassid = params["id"];
    //  if (this.hcpClassid != undefined)
    //    this.getDetails(this.hcpClassid);
    //});
  }

  getBusinessUnits() {
    this.businessUnitService.getBusinessUnitsRootLevel(true).subscribe(res => {
      this.businessUnits = res as BusinessUnit[];
      if (this.businessUnits && this.hcpclass)
      this.hcpclass.businessUnit = this.businessUnits.find(x => { return x.id == this.hcpclass.businessUnitId });

      
    });
  }
  getMonthData(id) {
    return this.hcpclass.months != null && this.hcpclass.months.find(x => x.month == id) != null ?
      this.hcpclass.months.find(x => x.month == id).visitsPerPlan
      : 0;
  }

  setMonthData(id, val: any) {
    try {
      if (!this.hcpclass.months)
        this.hcpclass.months = [];

      let entry = this.hcpclass.months.find(
        x => x.month === id
      );
      if (entry)
        entry.visitsPerPlan = Number(val);
      else {

        this.hcpclass.months.push({ month: id, visitsPerPlan: Number(val) })
      }
    }
    catch (error) { }
  }

  save(form) {
    if (!form.invalid) {
      this.displayMode = DisplayModes.Loading;
      if (this.hcpclass.businessUnit)
        this.hcpclass.businessUnitId = this.hcpclass.businessUnit.id

      this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));
      this.hcpClassService.Save(this.hcpclass).subscribe(result => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Success;
        if (this.hcpclass.id == 0)
          this.hcpclass = new hcpClass();
        else
          this.closeEvent.emit(true);

        this.alertService.showMessage("", this.translateService.getTranslation("SavedSuccessfully"), MessageSeverity.Success);
      }, err => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Error;
      });
    }
  }

  back() {
    //this.router.navigate(['hcp-classes']);
    this.closeEvent.emit(false);
  }

  getDetails(id) {
    this.displayMode = DisplayModes.Loading;
    this.hcpClassService.GetById(id).subscribe(response => {
      this.displayMode = DisplayModes.Success;
      this.hcpclass = response as any;
      if (this.businessUnits)
        this.hcpclass.businessUnit = this.businessUnits.find(x => { return x.id == this.hcpclass.businessUnitId });
    }, err => {
      this.displayMode = DisplayModes.Error;
    });
  }

}
